import React from "react";
import { Text, View } from "@react-pdf/renderer";

const ProluxFan = ({
  fanCalculation,
  airflow,
  sound_power_OUT_125,
  sound_power_OUT_250,
  sound_power_OUT_500,
  sound_power_OUT_1000,
  sound_power_OUT_2000,
  sound_power_OUT_4000,
  sound_power_OUT_8000,
  sound_power_IN_125,
  sound_power_IN_250,
  sound_power_IN_500,
  sound_power_IN_1000,
  sound_power_IN_2000,
  sound_power_IN_4000,
  sound_power_IN_8000,
  sound_power_in,
  sound_power_out,
}) => {
  return (
    <View
      wrap={false}
      style={{
        border: "2px solid black",
        fontSize: "8px",
        marginTop: "10px",
        paddingHorizontal: "5px",
        // pageBreakAfter: "always",
        // pageIbreakInside: "avoid",
        pageBreakBefore: "always",
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          borderBottom: "1px solid black",
        }}
      >
        <View style={{ width: "70%" }}>
          <Text style={{ fontSize: "10px", fontWeight: "600" }}>
            Ventilatorteil mit freilaufendem Radiallaufrad mit Direktantrieb
          </Text>
        </View>
      </View>

      <View style={{ display: "flex", flexDirection: "row" }}>
        <View style={{ width: "2%" }}>
          <Text>1</Text>
        </View>
        <View
          style={{
            width: "96%",
            borderLeft: "1px solid black",
            borderRight: "1px solid black",
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "center",
            }}
          >
            <View
              style={{
                paddingLeft: "2px",
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "25%",
              }}
            >
              <Text>Gesamt-Volumenstrom</Text>
              <Text>{airflow}</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "25%",
              }}
            >
              <Text>Druckverlust Extern</Text>
              <Text>{fanCalculation.externalPressDrop} Pa</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "25%",
              }}
            >
              <Text>Druckverlust Gerät</Text>
              <Text>{fanCalculation.internalPressDrop} Pa</Text>
            </View>
            <View
              style={{
                // borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "25%",
              }}
            >
              <Text>Gesamt Druckerhöhung</Text>
              <Text>{fanCalculation.totalPressDrop} Pa</Text>
            </View>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "center",
              borderTop: "1px solid black",
            }}
          >
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "50%",
                borderRight: "1px solid black",
                // flex: "1",
              }}
            >
              <Text>"Schallleistungspegel saugseitig 125 - 8000 Hz"</Text>
              <Text>
                {" "}
                {sound_power_OUT_125} {sound_power_OUT_250}{" "}
                {sound_power_OUT_500} {sound_power_OUT_1000}{" "}
                {sound_power_OUT_2000} {sound_power_OUT_4000}{" "}
                {sound_power_OUT_8000} dBA
              </Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "50%",
                // borderRight: "1px solid black",
                // flex: "1",
              }}
            >
              <Text>Schallleistungspegel total saugseitig 125 - 8000 dBA</Text>
              <Text>{sound_power_out} dBA</Text>
            </View>
          </View>
          <View
            style={{
              //   paddingLeft: "2px",
              borderTop: "1px solid black",
              display: "flex",
              flexDirection: "row",
              textAlign: "center",
            }}
          >
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "50%",
                borderRight: "1px solid black",
              }}
            >
              <Text>"Schallleistungspegel druckseitig 125 - 8000 Hz"</Text>
              <Text>
                {sound_power_IN_125} {sound_power_IN_250} {sound_power_IN_500}{" "}
                {sound_power_IN_1000}
                {sound_power_IN_2000}
                {sound_power_IN_4000}
                {sound_power_IN_8000} dBA
              </Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "50%",
              }}
            >
              <Text>Schallleistungspegel total druckseitig 63 - 8000 dBA</Text>
              <Text> {sound_power_in} dBA</Text>
            </View>
          </View>
          <View
            style={{
              borderTop: "1px solid black",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "15%",

                textAlign: "center",
              }}
            >
              <Text>Ventilator Fabrikat {"          "}</Text>
              <Text>Ebm Past</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "15%",

                textAlign: "center",
              }}
            >
              <Text>Ventilator Typ {"                             "}</Text>
              <Text>{fanCalculation.type}</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "10%",

                textAlign: "center",
              }}
            >
              <Text>k-Faktor Messdüse</Text>
              <Text>{fanCalculation.kFactor}</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "10%",

                textAlign: "center",
              }}
            >
              <Text>Wirkdruck Messdüse</Text>
              <Text>/</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "15%",

                textAlign: "center",
              }}
            >
              <Text>Leistungsbedarf Laufrad</Text>
              <Text>/</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "15%",

                textAlign: "center",
              }}
            >
              <Text>Wirkungsgrad Laufrad</Text>
              <Text>/</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "20%",

                textAlign: "center",
              }}
            >
              <Text>Ventilator Drehzahl {"                        "}</Text>
              <Text>{fanCalculation.rotationSpeed} 1/min</Text>
            </View>
          </View>
          <View
            style={{
              //   paddingLeft: "2px",
              borderTop: "1px solid black",
              display: "flex",
              flexDirection: "row",
              textAlign: "center",
            }}
          >
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "25%",
                borderRight: "1px solid black",
              }}
            >
              <Text>SFP-value:</Text>
              <Text>{fanCalculation.sfpValue} KWs/m³</Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "25%",
                borderRight: "1px solid black",
              }}
            >
              <Text>SFP-Faktor</Text>
              <Text>{fanCalculation.sfpClass}</Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "15%",
                borderRight: "1px solid black",
              }}
            >
              <Text> </Text>
              <Text> </Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "15%",
                borderRight: "1px solid black",
              }}
            >
              <Text> </Text>
              <Text> </Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
                borderRight: "1px solid black",
              }}
            >
              <Text> </Text>
              <Text> </Text>
            </View>
          </View>
          <View
            style={{
              borderTop: "1px solid black",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "10%",

                textAlign: "center",
              }}
            >
              <Text>Motor</Text>
              <Text>ebmpapst{/*fanCalculation.motor*/}</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "15%",

                textAlign: "center",
              }}
            >
              <Text>Motor Typ</Text>
              <Text>{fanCalculation.motor_type}</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "10%",

                textAlign: "center",
              }}
            >
              <Text>Schutzart</Text>
              <Text>{fanCalculation.protectionClass}</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "15%",

                textAlign: "center",
              }}
            >
              <Text>Motor Nennleistung</Text>
              <Text>{fanCalculation.power} kW</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "15%",

                textAlign: "center",
              }}
            >
              <Text>Motor Nennstrom</Text>
              <Text>{fanCalculation.ratedCurrent}</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "15%",

                textAlign: "center",
              }}
            >
              <Text>Motor Nenndrehzal</Text>
              <Text>{fanCalculation.motorRotSpeed} 1/min</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "20%",

                textAlign: "center",
              }}
            >
              <Text>Netzspannung / Frequenz</Text>
              <Text>{fanCalculation.powerSupply}</Text>
            </View>
          </View>
          <View
            style={{
              paddingLeft: "2px",
              borderTop: "1px solid black",
            }}
          >
            <Text style={{ fontWeight: "600", fontSize: "10px" }}>
              <b>Zubehör</b>
            </Text>
            <Text style={{}}>1 Volumenstrom-Messvorrichtung</Text>
          </View>
          <View
            style={{
              paddingLeft: "2px",
              borderTop: "1px solid black",
              height: "30px",
            }}
          >
            <Text style={{ fontWeight: "600", fontSize: "10px" }}>
              Bemerkungen:
            </Text>
            <Text>- EC-Motor mit Controller integriert</Text>
            <Text>- Spezifische Ventilatoren-Leistung</Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ProluxFan;
